import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/wordmark.svg'
import _imports_1 from '@/assets/icons/search.svg'


const _hoisted_1 = { class: "flex items-center justify-between flex-wrap p-6 max-w-screen-xl mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo flex items-center"
}, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-1 mt-1 h-4"
}, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "" }, "SEARCH", -1 /* HOISTED */)
const _hoisted_6 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Wallet")
const _hoisted_8 = {
  style: {"min-width":"200px"},
  class: "pb-2"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Search Transaction ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://docs.nomad.xyz/token-bridge/how-to-bridge",
  target: "_blank",
  class: "nav-link rounded-lg hover:bg-white hover:bg-opacity-5 px-2"
}, " Bridge Guide ", -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Connect Wallet ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_ChevronDown = _resolveComponent("ChevronDown")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_nomad_button = _resolveComponent("nomad-button")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createCommentVNode(" left side of nav "),
    _createCommentVNode(" company wordmark "),
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" right side of nav "),
    _createElementVNode("div", _hoisted_3, [
      _createCommentVNode(" search "),
      (_ctx.showSearch)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/tx",
            class: "flex items-center mr-6 opacity-70 hover:underline hover:opacity-90"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" connect wallet button "),
      (_ctx.showButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createCommentVNode(" connected "),
            (_ctx.walletConnected)
              ? (_openBlock(), _createBlock(_component_n_tooltip, {
                  key: 0,
                  placement: "bottom-end",
                  "show-arrow": false,
                  trigger: "click"
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_component_nomad_button, {
                      class: "btn-wallet-connected",
                      disabled: _ctx.buttonDisabled
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_text, { class: "mr-2 btn-connected-wallet-text uppercase" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_n_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.truncatedAddress), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_n_icon, {
                          size: "12",
                          class: "ml-2 pt-0.5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ChevronDown)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        to: "/tx",
                        class: "nav-link rounded-lg hover:bg-white hover:bg-opacity-5 px-2"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_n_divider, { class: "divider" }),
                      _hoisted_10
                    ])
                  ]),
                  _: 1 /* STABLE */
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" connect to wallet button "),
                  _createVNode(_component_nomad_button, {
                    class: "uppercase",
                    disabled: _ctx.buttonDisabled,
                    primary: "",
                    onClick: _ctx.handleConnect
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled", "onClick"])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}